// Employee analysis (/employee-analysis) and the FTE dialog. Project, role and
// tariff names are stored values; the Excel file stays Turkish.
const employeeAnalysis = {
  page: {
    title: 'Employee Analysis',
    subtitle: 'Projects, roles, visit counts and expenses per employee.',
  },
  actions: {
    excel: 'Download Table',
    excelHint: 'Download every assignment with its payment details as Excel',
  },
  stats: {
    workers: 'Total Employees',
    workersShort: 'Employees',
    projects: 'Active Projects',
    projectsShort: 'Projects',
    visits: 'Total Visits',
    visitsShort: 'Visits',
    expense: 'Total Expense',
    expenseShort: 'Expense',
    loading: 'loading…',
  },
  toolbar: {
    search: 'Search (name, project, role)…',
    searchShort: 'Search…',
    sort: 'Sort',
    sortBy: {
      name: 'Employee',
      projects: 'Project count',
      visits: 'Total visits',
      expense: 'Total expense',
    },
    asc: 'Ascending',
    desc: 'Descending',
  },
  columns: {
    employee: 'Employee',
    project: 'Projects',
    role: 'Roles',
    visits: 'Total Visits',
    expense: 'Total Expense',
  },
  table: {
    listLabel: 'Employees',
    empty: 'No data match the filters',
    rangeOf: 'of {{total}} employees',
    ofTotal: 'out of {{total}} employees',
    jump: 'Go to page',
    projectCount: '{{count}} projects',
    cardLine: '{{projects}} projects · {{visits}} visits',
  },
  panel: {
    label: 'Selected employee',
    heading: 'Employee analysis',
    summary: '{{projects}} projects · {{visits}} visits · {{expense}}',
    projectsOnly: '{{projects}} projects',
    fte: 'FTE Management',
    statistics: 'Statistics',
    assignments: 'Project assignments',
    rate: 'Tariff: {{type}} – {{value}}',
    assignmentTotals: '{{visits}} visits · {{expense}} expense',
    loadingDetails: 'Loading visits and expenses…',
    visits: 'Visits',
    tariffs: 'Tariff details',
    noTariffs: 'No tariff information for this employee.',
    tariffTotal: 'Tariff total',
  },
  fte: {
    title: 'FTE Management',
    subtitle: '{{name}} · project-based FTE assignments',
    empty: 'No project assignments for this employee',
    current: 'Current: {{type}} – {{value}}',
    choose: 'FTE choice',
    placeholder: 'Choose',
    noTariffs: 'No FTE tariff is defined for this project.',
    projectsError: 'Error loading projects',
    tariffsError: 'Error loading tariffs',
    saveError: 'Error saving the FTE information',
  },
  common: {
    cancel: 'Cancel',
    save: 'Save',
    saving: 'Saving…',
    loading: 'Loading…',
  },
  toast: {
    loadError: 'Error loading employees!',
    bulkError: 'Error loading visit, expense and payment data.',
    noVisits: 'No visits found for this employee.',
    visitsError: 'Error loading the visits.',
    refreshing: 'Updating data…',
    fteSaved: 'FTE information updated!',
    refreshError: 'Error updating the data',
    excelDone: 'Excel file downloaded successfully',
    pageJumpInvalid: 'Please enter a page number between 1 and {{max}}.',
  },
};

export default employeeAnalysis;
